import util from "@/common/util";

let recaptchaPs = null;
const SITE_KEY = '6Lf21EksAAAAAMIg0YOBDMFKJs5_avo_v9MaAb2Y';

const loadRecaptcha = () => {
    if (util.isSSRServer) {
        return Promise.resolve();
    }
    if (recaptchaPs) {
        return recaptchaPs;
    }
    const callbackName = `recaptchaCallback_${Math.random().toString(36).substring(2, 15)}`;
    recaptchaPs = Promise.race([
        new Promise((resolve) => {
            window[callbackName] = () => {
                resolve();
            }
        }),
        new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, 10000);
        })
    ]);
    util.addScript(`https://www.google.com/recaptcha/api.js?onload=${callbackName}&render=${SITE_KEY}`);
    return recaptchaPs;
}

// init recaptcha
loadRecaptcha();

export const getVerifyToken = async(data = {}) => {
    if (util.isSSRServer) {
        return Promise.resolve({});
    }
    let token = '';
    await loadRecaptcha();
    try {
        const t = await grecaptcha.execute(SITE_KEY, { action: 'submit' });
        token = t;
    } catch (e) {
        console.error('getVerifyToken error', e);
    } finally {
        //  If captcha pops up but no verification is performed 
        console.error('getVerifyToken error', 'Please verify that you are not a robot.');
    }
    return token;
}

export const fillCaptchaToken = async(config = {}) => {
    // 检查是否启用 Google reCAPTCHA
    if (util.isSSRServer) {
        return;
    }

    const globalData = window.sitePrepareData();
    const useGoogleRecaptcha = globalData?.useGoogleRecaptcha;

    if (!useGoogleRecaptcha) {
        return;
    }

    try {
        const token = await getVerifyToken();
        if (token) {
            // 将 token 添加到请求头
            config.headers = config.headers || {};
            config.headers['recaptcha_token'] = token;
        }
    } catch (error) {
        console.error('Failed to get captcha token:', error);
    }
}
